<template>
  <div class="users-detail-vertify" v-loading="loading">
    <template v-if="userData.state === 'UN_CERTIFICATE'">
      <div class="no-vertify-info">
        <i class="el-icon-warning"></i>
        <p>该用户还未提交个人身份认证/企业资质认证申请</p>
      </div>
    </template>
    <template v-else>
      <ul class="vertify-form" v-if="cert">
        <li class="form-item">
          <span class="form-item-label">认证类型：</span>
          <div class="form-item-content">
            个人身份认证
          </div>
        </li>
        <li class="form-item">
          <span class="form-item-label">认证状态：</span>
          <div class="form-item-content">
            <template v-if="cert.state === 'CERTIFIED'">
              <i class="el-icon-circle el-icon-circle-check" style="background-color:#005bff"></i>
              <span>审核通过</span>
            </template>
            <template v-else-if="cert.state === 'WAITING'">
              <i class="el-icon-circle el-icon-time" style="background-color:#00BD83"></i>
              <span>待审核</span>
            </template>
            <template v-else>
              <i class="el-icon-circle el-icon-circle-close" style="background-color:#FF5753"></i>
              <span>审核失败</span>
            </template>
          </div>
        </li>
        <li class="form-item" v-if="cert.state === 'INVALID'">
          <span class="form-item-label">审核不通过原因：</span>
          <div class="form-item-content" style="color:#FF5753;">
            {{ cert.opinion }}
          </div>
        </li>
        <li class="form-item">
          <span class="form-item-label">真实姓名</span>
          <div class="form-item-content">
            {{ cert.realName }}
          </div>
        </li>
        <li class="form-item">
          <span class="form-item-label">身份证号</span>
          <div class="form-item-content">
            {{ cert.identityNo }}
          </div>
        </li>
        <li class="form-item">
          <span class="form-item-label">所属行业</span>
          <div class="form-item-content">
            {{ cert.profession }}
          </div>
        </li>
        <li class="form-item">
          <span class="form-item-label">身份证正反面：</span>
          <div class="form-item-content">
            <img class="identify-card" v-preview v-pic.oauth="cert.identityUpSide" />
            <img class="identify-card" v-preview v-pic.oauth="cert.identityDownSide" />
          </div>
        </li>
        <li class="form-item">
          <span class="form-item-label">提交审核时间：</span>
          <div class="form-item-content">
            <span>{{ cert.createdDate }}</span>
            <span class="action" v-if="cert.state === 'WAITING'" @click="showVertifyLog">认证审核记录</span>
          </div>
        </li>
        <li class="form-item" v-if="cert.state !== 'WAITING'">
          <span class="form-item-label">审核时间：</span>
          <div class="form-item-content">
            <span>{{ cert.certificateTime }}</span>
            <span class="action" @click="showVertifyLog">认证审核记录</span>
          </div>
        </li>
      </ul>
      <ul class="vertify-form" v-if="e_cert">
        <li class="form-item">
          <span class="form-item-label">认证类型：</span>
          <div class="form-item-content">
            企业资质认证
          </div>
        </li>
        <li class="form-item">
          <span class="form-item-label">认证状态：</span>
          <div class="form-item-content">
            <template v-if="e_cert.state === 'CERTIFIED'">
              <i class="el-icon-circle el-icon-circle-check" style="background-color:#005bff"></i>
              <span>审核通过</span>
            </template>
            <template v-else-if="e_cert.state === 'WAITING'">
              <i class="el-icon-circle el-icon-time" style="background-color:#00BD83"></i>
              <span>待审核</span>
            </template>
            <template v-else-if="e_cert.state === 'UPDATE'">
              <i class="el-icon-circle el-icon-time" style="background-color:#00BD83"></i>
              <span>升级企业认证中</span>
            </template>
            <template v-else>
              <i class="el-icon-circle el-icon-circle-close" style="background-color:#FF5753"></i>
              <span>审核失败</span>
            </template>
          </div>
        </li>
        <li class="form-item" v-if="e_cert.state === 'INVALID'">
          <span class="form-item-label">审核不通过原因：</span>
          <div class="form-item-content" style="color:#FF5753;">
            {{ e_cert.opinion }}
          </div>
        </li>
        <li class="form-item">
          <span class="form-item-label">企业名称</span>
          <div class="form-item-content">
            {{ e_cert.realName }}
          </div>
        </li>
        <li class="form-item">
          <span class="form-item-label">纳税人识别号</span>
          <div class="form-item-content">
            {{ e_cert.identityNo }}
          </div>
        </li>
        <li class="form-item">
          <span class="form-item-label">营业执照：</span>
          <div class="form-item-content">
            <img class="identify-card" v-preview v-pic.oauth="e_cert.identityUpSide" />
          </div>
        </li>
        <li class="form-item">
          <span class="form-item-label">法定代表人：</span>
          <div class="form-item-content">
            {{ e_cert.legalPerson }}
          </div>
        </li>
        <li class="form-item">
          <span class="form-item-label">法定代表人身份证号：</span>
          <div class="form-item-content">
            {{ e_cert.legalPersonIdentityNo }}
          </div>
        </li>
        <li class="form-item">
          <span class="form-item-label">法定代表人身份证正反面：</span>
          <div class="form-item-content">
            <img class="identify-card" v-preview v-pic.oauth="e_cert.legalPersonIdentityUpSide || 'upside'" />
            <img class="identify-card" v-preview v-pic.oauth="e_cert.legalPersonIdentityDownSide || 'downside'" />
          </div>
        </li>
        <li class="form-item">
          <span class="form-item-label">提交审核时间：</span>
          <div class="form-item-content">
            <span>{{ e_cert.createdDate }}</span>
            <span v-if="e_cert.state === 'WAITING'" class="action" @click="showVertifyLog">认证审核记录</span>
          </div>
        </li>
        <li class="form-item" v-if="['CERTIFIED', 'INVALID'].includes(e_cert.state)">
          <span class="form-item-label">审核时间：</span>
          <div class="form-item-content">
            <span>{{ e_cert.certificateTime }}</span>
            <span class="action" @click="showVertifyLog">认证审核记录</span>
          </div>
        </li>
      </ul>
      <div class="btn-grp" v-if="['WAITING', 'UPDATE'].includes(userData.state)">
        <el-button @click="pass">审核通过</el-button>
        <el-button
          @click="
            dialogVisible = true;
            dialogTitle = '审核不通过';
          "
        >
          审核不通过
        </el-button>
      </div>
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
        <div v-if="dialogTitle === '认证审核记录'" class="vertify-log-list">
          <template v-for="(a, i) in auditList">
            <time-line
              :key="a.id"
              :timestamp="a.createdDate"
              :context="`用户提交${a.type === 'PERSONAL' ? '个人认证' : '企业认证'}审核。`"
              :finished="i === auditList.length - 1 && ['WAITING', 'UPDATE'].includes(a.state)"
            ></time-line>
            <time-line
              v-if="['CERTIFIED', 'INVALID'].includes(a.state)"
              :key="a.id"
              :timestamp="a.certificateTime"
              :context="`${a.state === 'CERTIFIED' ? '审核通过' : `审核未通过，原因：${a.opinion}`}。`"
              :addon="formatterAuditor(a.auditUser)"
              :finished="i === auditList.length - 1"
            ></time-line>
          </template>
        </div>
        <template v-if="dialogTitle === '审核不通过'">
          <el-form label-width="120px">
            <el-form-item label="审核不通过原因:">
              <el-input v-model="opinion" type="textarea" rows="7" resize="none"></el-input>
            </el-form-item>
          </el-form>
          <span class="btn-grp dialog-footer" slot="footer">
            <el-button @click="fail">确定</el-button>
            <el-button @click="dialogVisible = false">取消</el-button>
          </span>
        </template>
      </el-dialog>
    </template>
  </div>
</template>

<script>
import timeLine from '@/components/timeLine';
import { getAuditListByUserId, getUserBySubId, syncUserInfoById, updateAuditByUserIdAndId } from '@/api/req';
import { STATUS } from '../_eum';
import axios from 'axios';

export default {
  name: 'userDetailVertify',
  components: { timeLine },
  data() {
    return {
      loading: true,
      dialogVisible: false,
      dialogTitle: '',
      userData: {},
      auditList: [],
      opinion: ''
    };
  },
  computed: {
    subId() {
      return this.$route.params.subId;
    },
    userId() {
      return this.$route.params.id;
    },
    cert() {
      return this.userData.certification || '';
    },
    e_cert() {
      return this.userData.enterPriseCertification || '';
    }
  },
  methods: {
    showVertifyLog() {
      this.dialogTitle = '认证审核记录';
      this.dialogVisible = true;
    },
    getData() {
      this.loading = true;
      this.$ajax
        .get(getUserBySubId(this.subId))
        .then(({ data }) => {
          this.loading = false;
          // this.userData = Object.freeze(data);
          this.userData = data;
        })
        .catch(err => {
          this.loading = false;
          this.$message.info(`加载失败,${err.data}`);
          console.log('err :>> ', err);
        });
    },
    getVertifyLog() {
      this.$ajax
        .get(getAuditListByUserId(this.userId))
        .then(({ data }) => {
          this.auditList = data;
        })
        .catch(err => {
          console.log('err :>> ', err);
        });
    },
    pass() {
      this.loading = true;
      const { userId, userData } = this;
      let id;
      if (userData.type === 'PERSONAL' && userData.state === STATUS.UPDATE) {
        id = this.e_cert.id;
      } else if (userData.type === 'PERSONAL' && userData.state === STATUS.WAITING) {
        id = this.cert.id;
      } else if (userData.type === 'ENTERPRISE' && userData.state === STATUS.WAITING) {
        id = this.e_cert.id;
      }
      const req = {
        id,
        pass: true,
        opinion: ''
      };
      this.$ajax
        .put(updateAuditByUserIdAndId(userId, id), req)
        .then(res => {
          this.loading = false;
          this.$message.success('审核成功');
          this.syncUserInfo(userId);
          this.getData();
        })
        .catch(err => {
          this.loading = false;
          console.log('err :>> ', err);
          this.$message.info('审核失败');
        });
    },
    fail() {
      const { userId, opinion, userData } = this;
      if (!opinion) {
        this.$message.info('审核不通过原因不能为空！');
        return;
      }
      this.loading = true;
      let id;
      if (userData.type === 'PERSONAL' && userData.state === STATUS.UPDATE) {
        id = this.e_cert.id;
      } else if (userData.type === 'PERSONAL' && userData.state === STATUS.WAITING) {
        id = this.cert.id;
      } else if (userData.type === 'ENTERPRISE' && userData.state === STATUS.WAITING) {
        id = this.e_cert.id;
      }
      const req = {
        id,
        pass: false,
        opinion
      };
      this.$ajax
        .put(updateAuditByUserIdAndId(userId, id), req)
        .then(res => {
          this.loading = false;
          this.$message.success('审核成功');
          this.syncUserInfo(userId);
          this.getData();
          this.dialogVisible = false;
        })
        .catch(err => {
          this.loading = false;
          console.log('err :>> ', err);
          this.$message.info('审核失败');
        });
    },
    formatterAuditor(auditinfo) {
      if (!auditinfo) return '';
      let auditName = '';
      if (auditinfo.state === 'CERTIFIED') {
        switch (auditinfo.type) {
          case 'PERSONAL':
            auditName = auditinfo?.certification?.realName;
            break;
          case 'ENTERPRISE':
            auditName = auditinfo?.enterPriseCertification?.legalPerson;
            break;
          default:
            auditName = auditinfo.profile.nickname;
            break;
        }
      }
      return `审核员：${auditName || auditinfo.profile.nickname}`;
    },
    syncUserInfo(userId) {
      // 更新另一个系统的信息
      const updateForm = new FormData();
      updateForm.append('userId', userId);
      // 项目封装的put方法不支持设置头部，也不能自动判断数据类型来设置头部，故重新引入Axios
      axios.put(syncUserInfoById, updateForm, {
        headers: {
          Authorization: 'Bearer ' + sessionStorage.getItem('token')
        }
      });
    }
  },
  created() {
    this.getData();
    this.getVertifyLog();
  }
};
</script>

<style lang="scss">
.users-detail-vertify {
  min-height: 650px;
  display: flex;
  flex-direction: column;
  ul,
  li {
    list-style: none;
  }
  .vertify-form {
    margin-bottom: 16px;
    padding: 24px 20px;
    background-color: white;
    border-radius: 4px;
    flex: 1;
  }
  .btn-grp {
    padding: 24px 20px;
    background-color: white;
    border-radius: 4px;
    .el-button {
      padding: 13px 30px;
      border-color: #002b9c;
      color: #002b9c;
      &:not(.is-disabled):hover {
        background-color: #002b9c;
        color: white;
      }
    }
    .is-disabled {
      border: 1px dashed #8998a0;
      color: #8998a0;
    }
  }
  .form-item {
    margin-top: 20px;
    display: flex;
    align-items: center;
    &:first-child {
      margin-top: 0;
    }
    &-label {
      height: 20px;
      font-size: 12px;
      font-weight: 500;
      color: #8998a0;
      line-height: 20px;
      width: 150px;
      margin-right: 6px;
    }
    &-content {
      font-size: 14px;
      font-weight: 400;
      color: #040b28;
      line-height: 20px;
      .icon {
        display: inline-block;
        vertical-align: middle;
        margin-right: 8px;
      }
      img {
        height: 94px;
        width: 94px;
        border-radius: 4px;
        font-size: 0;
        vertical-align: bottom;
      }
      .identify-card {
        margin-right: 12px;
        height: 118px;
        width: 188px;
      }
      .el-icon-circle {
        margin-right: 8px;
        color: #fff;
        vertical-align: middle;
      }
      .el-switch {
        height: 20px;
      }
      .action {
        color: #005bff;
        font-size: 14px;
        cursor: pointer;
        margin-left: 16px;
      }
    }
  }
  .vertify-log-list {
    // padding-right: 20px;
    padding-left: 80px;
  }
  .no-vertify-info {
    min-height: 580px;
    padding: 40px;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 18px;
    color: #8998a0;
    i {
      margin-bottom: 20px;
      font-size: 60px;
      color: #c2c4c7;
      height: 60px;
      width: 60px;
      overflow: hidden;
    }
  }
}
</style>
